// Guard against multiple concurrent logout calls. Parallel 401 responses can
// each trigger performLogout, racing with the error boundary's redirectToScreen.
// performLogout POSTs to /logout which redirects back to the app root, while
// redirectToScreen navigates to the login form — the first one to win determines
// where the user lands, causing a reload loop when performLogout wins repeatedly.
let isLoggingOut = false;

export const performLogout = (returnTo?: string): void => {
  if (isLoggingOut) {
    return;
  }
  isLoggingOut = true;

  const form = document.createElement('form');
  form.method = 'POST';
  form.action = `${
    window.location.origin
  }/api/v1/auth/logout?returnTo=${encodeURIComponent(
    returnTo || window.location.origin
  )}`;
  form.style.display = 'none';

  document.body.appendChild(form);
  form.submit();
};
